// Hook odpowiedzialny za pobranie alertow do wyswietlenia w widoku koszyka

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface ICartAlertItem {
  message: string;
  icon: string | null;
  color: string;
  url: string | null;
  button_label: string | null;
}

interface IResponse {
  page: number;
  total_count: number;
  total_pages: number;
  items: ICartAlertItem[];
}

const getCartAlerts = (cartId: number): Promise<IResponse> =>
  axios.get(`carts/${cartId}/alerts`);

export const useGetCartAlerts = (
  cartId: number,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(['cart-alerts', cartId], () => getCartAlerts(cartId), options);
